import React, { useEffect, useState } from "react";
import { ITheme, useClasses, SelectCustom, ICol } from "@maxeb/admin-ui";

import { Theme, ITheme as IArtTheme } from "@maxeb/art-sdk";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";

export interface IProps extends ICol {
  value?: string;
  onChange: (value: string) => void;
}

export interface IState {
  status: "init" | "ok" | "pending" | "error" | "success";
  search: { open: boolean; name?: string; direction: "ASC" | "DESC" };
  data: IArtTheme[];
  value?: string;
}

const styles = (theme: ITheme) => ({
  curtain: {
    zIndex: "201 !important",
  },
  list: {
    padding: "0px",
    margin: "0px",
    listStyle: "none",
  },
  listElement: {
    cursor: "pointer",
    height: "32px",
    lineHeight: "32px",
    margin: "0px -16px",
    padding: "5px 24px  5px 24px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "&:hover": {
      backgroundColor: theme.palette.get("primary"),
      color: "#fff",
    },
  },
  pending: {
    fontSize: "4rem",
    textAlign: "center",
    color: theme.palette.get("primary"),
  },
});

let MOUNTED = false;

export async function init(
  props: IProps,
  state: IState,
  setState: (state: IState) => void
) {
  setState({ ...state, status: "pending" });
  try {
    const result = await Theme.get(
      {},
      ["id", "name", "nameDe"],
      20,
      "secondaryIndex",
      state.search.direction
    );

    if (MOUNTED) {
      if (result.isSuccess()) {
        const value = result.body.data.find(
          (element: IArtTheme) => props.value === element.id
        )?.name;

        setState({ ...state, status: "ok", data: result.body.data, value });
      }
    }
  } catch (err) {
    console.error(err);
    if (MOUNTED) setState({ ...state, status: "error" });
  }
}

export default function ArtistsSelect(props: IProps) {
  const classes = useClasses(styles);

  const [state, setState] = useState<IState>({
    status: "init",
    search: { open: false, direction: "ASC" },
    data: [],
  });

  const [open, setOpen] = useState(false);

  const { status, data } = state;

  useEffect(() => {
    MOUNTED = true;
    if (status === "init") init(props, state, setState);

    return () => {
      MOUNTED = false;
    };
  }, [status, props, state]);

  return (
    <SelectCustom
      inline
      label="Theme"
      {...props}
      open={open}
      value={state.value}
      setOpen={() => {
        setOpen(!open);
      }}
      override={{ curtain: classes.curtain }}
    >
      <ul className={classes.list}>
        <li
          className={classes.listElement}
          onClick={() => {
            setState({ ...state, value: "" });
            props.onChange("");
          }}
        >
          Keine
        </li>
        {data.map((theme) => (
          <li
            key={`artist-${theme.id}`}
            className={classes.listElement}
            onClick={() => {
              setState({ ...state, value: theme.name });
              props.onChange(theme.id || "");
            }}
          >
            {theme.name}
          </li>
        ))}
        {(state.status === "init" || state.status === "pending") && (
          <li className={classes.pending}>
            <FontAwesomeIcon icon={faSpinnerThird} spin />
          </li>
        )}
      </ul>
    </SelectCustom>
  );
}
